import useSWR from 'swr';
import { PassService } from '../../api';

const fetcher = async ({ eventId }: { eventId: string }) => PassService.getEventPassHolders(eventId);

type UseEventPassHoldersProps = {
  eventId?: string;
  enabled?: boolean;
};

export const useEventPassHolders = ({ eventId, enabled = true }: UseEventPassHoldersProps) => {
  const { data, error, isLoading, mutate } = useSWR(
    enabled && eventId
      ? {
          eventId,
          opId: 'getEventPassHolders',
        }
      : null,
    fetcher,
    { refreshInterval: 10000 },
  );

  return {
    holders: data?.holders || [],
    weeklyHoldersCount: data?.weekly_holders_count || 0,
    slotCapacity: data?.slot_capacity || 0,
    isLoading,
    isError: error,
    mutate,
  };
};
